import { api } from 'utility';
import {
  getCarTableListUrl,
  getCartableRequestListsUrl,
  getCreditUrl,
  getCaptchaServiceUrl,
  getUserContactUrl,
  getTransferFromWalletUrl,
  getTransferFromGuildUrl,
  getFileUrl,
  cartableGroupRequestsWithrequestId,
  getCollectionCardURL,
  getLoanCreditFacilitiesUrl,
  getLoanAgrementIdUrl,
  getLoanAgrementUrl,
  getLoanLoanInvoicesUrl,
  getUserLoanCreditDetailUrl,
  getLoanUserInvoicesUrl,
  getLoanInstallmentUserListUrl,
  getLoanSettelmentUrl,
  getLoanPaymentInstallment,
  getLoanUserInstallment,
  getFinancingList,
  getBusinessPhoneNumber,
  requestPostFinancing,
  getCarTableListRelatedUrl
} from 'URLs';
import { stringify } from 'qs';
class Services {
  /**
   * لیست حساب های چند امضایی
   */
  getCarTableList(params) {
    return api.post(getCarTableListUrl(), params).then((res) => res.data);
  }
  /**
   * لیست درخواست ها
   */
  getCartableRequestList(params) {
    return api.get(getCartableRequestListsUrl(), { params }).then((res) => res.data);
  }
  getCartableRequestListRestfull(params) {
    const url = getCarTableListRelatedUrl();
    return api
      .get(url, {
        params,
        paramsSerializer: (params) => {
          return stringify(params, { arrayFormat: 'repeat' });
        },
      })
      .then((res) => res.data);
  }

  getCredit() {
    return api.get(getCreditUrl()).then((res) => res.data.result);
  }

  getCaptcha() {
    return api.get(getCaptchaServiceUrl()).then((res) => res.data);
  }
  checkContact(data) {
    return api.post(getUserContactUrl(), data).then((res) => res.data);
  }
  transferCreditContactWithWallet(cartableId, data) {
    return api.post(getTransferFromWalletUrl(cartableId), data).then((res) => res.data);
  }
  transferCreditContactWitGuild(cartableId, data) {
    return api.post(getTransferFromGuildUrl(cartableId), data).then((res) => res.data);
  }
  /**
   * درخواست فایل گزارش
   */
  async reportGroupRequest(requestId) {
    return api.post(cartableGroupRequestsWithrequestId(requestId)).then((res) => res.data);
  }
  /**
   * دریافت فایل گزارش
   */
  async reportGroupRequestReciveFile(requestId) {
    return api.get(cartableGroupRequestsWithrequestId(requestId)).then((res) => res.data.result);
  }
  /**
   * دریافت فایل خروجی
   */

  async getFile(params) {
    return api
      .get(getFileUrl(), {
        responseType: 'blob',
        params: { ...params, forceSave: false },
      })
      .then((res) => res.data);
  }
  /**
   *
   * کارت جمع
   */
  async requestCollectionCard(requestId) {
    return api.get(getCollectionCardURL(requestId)).then((res) => res.data.result);
  }

  /**
   * دریافت لیست اعتبار - منوی درخواست تامین مالی
   */
  async requestLoanCreditFacilities(params) {
    return api.get(getLoanCreditFacilitiesUrl(), { params }).then((res) => res.data);
  }

  /**
   * دریافت جزییات دیالوگ درخواست تامین مالی
   */
  async requestLoanAgreementId(id) {
    return api.get(getLoanAgrementIdUrl(id)).then((res) => res.data);
  }

  async reportLoanAgreement(data) {
    return api.post(getLoanAgrementUrl(), data, {}).then((res) => res.data);
  }

  /**
   * منوی فاکتورهای تامین مالی شده
   */
  async getLaonInvoce(params) {
    return api.get(getLoanLoanInvoicesUrl(), { params }).then((res) => res.data);
  }

  /**
   * عملیات جزییات - منوی فاکتورهای تامین مالی شده
   */
  async getLaonDetail(params) {
    return api.get(getUserLoanCreditDetailUrl(params)).then((res) => res.data);
  }

  /**
   * دریافت لیست پرداخت ها - زمانیکه از اکشن عملیات فاکتورهای تامین مالی شده به این صفحه روت میشود
   */
  async getLaonUser(params) {
    return api.get(getLoanUserInvoicesUrl(), { params }).then((res) => res.data);
  }
  /**
   * * دریافت لیست پرداخت ها - زمانیکه از منو تامین مالی - مشاهده و پرداخت اقساط انتخاب میشود
   */
  async getLaonInstalmentUser(params) {
    return api.get(getLoanInstallmentUserListUrl(), { params }).then((res) => res.data);
  }

  /**
   * پرداخت از اکشن عملیات
   */
  async retryToPayInstallment(installmentId) {
    return api.post(getLoanPaymentInstallment(), { installmentId }).then((res) => res.data);
  }
  /**
   * تسویه زودتر از موعد
   */
  async loanPerSettlement(loanId) {
    return api.post(getLoanSettelmentUrl(), { loanId });
  }

  async getUserInstallmentList(params) {
    return api.get(getLoanUserInstallment(), { params }).then((res) => res.data);
  }
  async retryToPayInstallment(installmentId) {
    return api.post(getLoanPaymentInstallment(), { installmentId }).then((res) => res.data);
  }

  async loanPerSettlement(loanId) {
    return api.post(getLoanSettelmentUrl(), { loanId });
  }

  async getFinancingListService(params) {
    return api.get(getFinancingList(), { params }).then((res) => res.data);
  }

  async getPhoneNumberUserLogin() {
    return api.get(getBusinessPhoneNumber(), {}).then((res) => res.data);
  }
  /**
   * ثبت درخواست تامین مالی - دیالوگ ثبت درخواست اعتبار دکه ثبت میشود
   */
  async requestFinancingPost(chainId) {
    return api.post(requestPostFinancing(chainId), {}, {});
  }
}

export default new Services();
